import Dexie from 'dexie';

const db = new Dexie('omniStorageDb');
db.version(1).stores({
  currentUser: `objectId, name`,
});

export default db;
